import {Datagrid, List, TextField, Filter, TextInput} from "react-admin";
import * as React from "react";

const PostFilter = (props) => (
    <Filter {...props} variant="outlined">
        <TextInput label="id" source="id" />
        <TextInput label="Name" source="name" />
        <TextInput label="City" source="city" />
        <TextInput label="State" source="state" />
    </Filter>
);

export const SiteList = (props) => {

    return (
        <List
            {...props}
            filters={<PostFilter />}
            empty={false}
        >
            <Datagrid rowClick="edit">>
                <TextField source="id"/>
                <TextField source="name"/>
                <TextField source="city"/>
                <TextField source="state"/>
            </Datagrid>
        </List>
    );
};

